module.exports = __webpack_public_path__ + "media/img/home/animate/item2-69ee26ae5c0045855c287033e4c8a4ee.svg";